module.exports = __webpack_public_path__ + "static/img/empty_3.27fd0ed7.png";